import { cloneRecord } from '../core/record';

/** Legacy MessageListItem renderer row carried through the feed engine for the surviving row components. */
export type EchoRendererRow = Record<string, unknown>;

/** Clones an echo API message row so render-time enrichment can mutate safely by replacement. */
export function cloneEchoRendererRow(row: Record<string, unknown>): EchoRendererRow {
  return cloneRecord<EchoRendererRow>(row);
}
